import React from 'react';
import { Button, ImageAtoms } from '@vfit/shared/atoms';
import { IRectangleBackground } from './rectangleBackground.models';
import {
  Title,
  Description,
  ButtonContainer,
  ExternalContainer,
  ImageContainer,
} from './rectangleBackground.style';

const rectangleBackground: React.FC<React.PropsWithChildren<IRectangleBackground>> = ({
  containerRef,
  data,
  handleClick,
  children,
}) => {
  const { title, description, ctaLabel, backgroundImage, isExternalImages } = data;
  return (
    <ExternalContainer ref={containerRef}>
      <>
        <ImageContainer>
          <ImageAtoms
            objectFit="cover"
            style={{
              position: 'absolute',
              borderRadius: '15px',
            }}
            image={backgroundImage}
            nameCard={title}
            external={isExternalImages}
          />
        </ImageContainer>
        <div style={{ position: 'relative', paddingTop: 80 }}>
          <Title>{title}</Title>
          <Description> {description} </Description>
          {!!ctaLabel && (
            <ButtonContainer>
              <Button variant="tertiary" onClick={handleClick}>
                {ctaLabel}
              </Button>
            </ButtonContainer>
          )}
          {!ctaLabel && <div style={{ height: 100 }} />}
        </div>
      </>
      {children}
    </ExternalContainer>
  );
};
export default rectangleBackground;
